import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import PageContainer from '../../../components/layout/page-container/PageContainer';
import LoadMoreFeedback from '../../../components/reusable/load-more-feedback/LoadMoreFeedback';
import Posts from '../../../components/reusable/posts/Posts';
import { useLazyLoad } from '../../../hooks/use-lazy-load';
import { useLazyGetNews } from '../../../redux/api/postsApi';
import { useStyles } from './News.style';

const News = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);

  const {
    items: posts,
    footerRef,
    refetchAll,
    isFetching: isFetchingPosts,
    error: postsError,
  } = useLazyLoad(useLazyGetNews, {}, (items) => ({
    timestamp: (items?.length
      ? new Date(items[items.length - 1]?.createdAt)
      : new Date()
    ).valueOf(),
  }));

  return (
    <PageContainer title={t('common.news')} onRefresh={refetchAll}>
      <Posts
        posts={posts ?? []}
        editable={false}
        refreshPosts={refetchAll}
        isLoading={(!posts || posts.length === 0) && Boolean(isFetchingPosts)}
      />
      <LoadMoreFeedback
        error={postsError}
        isFetching={Boolean(isFetchingPosts) && Boolean(posts?.length)}
        onRetry={refetchAll}
      />
      <Box ref={footerRef} mb={1} />
    </PageContainer>
  );
};

export default News;
